/**
 * Default parameter values for Agent Output Parser
 */
export const agentOutputParserDefaults = {
  expectedOutputType: 'either', // 'object', 'array', or 'either' (auto-detect from example)
  jsonExample: '{\n  "name": "John Doe",\n  "age": 30,\n  "email": "john@example.com"\n}',
  schemaDescription: '',
  strictValidation: true,
  enableAutoFix: true,
  enableRetry: true,
  maxRetries: 3,
  retryPromptTemplate: 'The previous output did not match the required format.\n\nRequired format:\n{instructions}\n\nYour previous output:\n{completion}\n\nError:\n{error}\n\nPlease provide the output again in the correct JSON format.',
  onValidationFailure: 'error',
  includeMetadata: true,
};
